import React, { useEffect, useMemo, useState } from 'react';
import ReactPlaceholder from 'react-placeholder/lib';
import { Input, FormCustom, SwitchToggle, Select } from '../../Components/Form/Form';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify';
import Controllers from '../../Api/Controllers';

const EmployeeForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
  const [row, setRow] = useState({
    p_id_employee: data.id_employee,
    p_name_employee: data.name_employee,
    p_last_name_employee: data.last_name_employee,
    p_rfc_employee: data.rfc_employee,
    p_curp_employee: data.curp_employee,
    p_contract_date_employee: data.contract_date_employee,
    p_salary_employee: data.salary_employee,
    p_sdi_imss_employee: data.sdi_imss_employee,
    p_imss_employee: data.imss_employee,
    p_salary_type: 'FIJO', // Valor fijo por ahora
    p_employer_registration: data.employer_registration,
    p_enabled_employee: data.enabled_employee || 0, // Estado por defecto 0 (Inactivo)
    p_zip_code_employee: data.zip_code_employee,
    p_journey_worker: data.journey_worker,
    // Nuevos campos
    p_id_supervisor: data.id_supervisor,
    p_is_boss: data.is_boss || 0,
    p_is_boss_rrhh: data.is_boss_rrhh || 0,
    p_id_worker: data.id_worker,
  });

  const [optionsJourneyWorker] = useState([
    { label: 'Lunes a Viernes', value: 'LUNES_VIERNES' },
    { label: 'Lunes a Sábado', value: 'LUNES_SABADO' },
    { label: 'Lunes a Domingo', value: 'LUNES_DOMINGO' }
  ]);

  const [ready, setReady] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    Promise.all([
      Controllers.employee.get_employee(),
      Controllers.worker.get_worker(),
    ]).then(res => {
      setEmployees(res[0]?.data || []);
      setWorkers(res[1]?.data || []);
      setReady(true);
    }).catch(req => Helpers.promise.catch({ req, toast }));
  }, []);

  const journey = useMemo(() => {
    if (!row.p_journey_worker) {
      return ''
    }

    let finded = optionsJourneyWorker.find(t => row.p_journey_worker === t.value)

    if (!finded) {
      return ''
    }
    return {
      label: finded.label,
      value: finded.value
    }
  }, [row.p_journey_worker, optionsJourneyWorker])

  const supervisorsOnly = useMemo(() => {
    return employees.filter(e => parseInt(e.is_boss || 0) === 1);
  }, [employees]);

  const supervisor = useMemo(() => {
    if (!row.p_id_supervisor) return '';
    const found = supervisorsOnly.find(e => parseInt(e.id_employee) === parseInt(row.p_id_supervisor));
    if (!found) return '';
    return {
      label: `${found.name_employee} ${found.last_name_employee}`,
      value: found.id_employee
    }
  }, [row.p_id_supervisor, supervisorsOnly]);

  const userOption = useMemo(() => {
    if (!row.p_id_worker) return '';
    const found = workers.find(u => parseInt(u.id_worker) === parseInt(row.p_id_worker));
    if (!found) return '';
    return {
      label: found.name_worker + ' ' + found.last_name_worker,
      value: found.id_worker
    }
  }, [row.p_id_worker, workers]);

  return (
    <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
      <FormCustom dataSubmit={row} onSubmit={({ data }) => {
        if (!row.p_journey_worker) {
          Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar una jornada', toast })
          return
        }
        if (!row.p_id_supervisor && parseInt(row.p_is_boss) !== 1) {
          Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar un supervisor', toast })
          return
        }
        onSubmit({ data })
      }} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
          text="Nombres"
          placeholder="Nombres"
          classNameParent="col-12 mb-2"
          icon="far fa-comment-alt"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.name_employee}
          onChange={e => setRow({ ...row, p_name_employee: e.currentTarget.value })}
          maxLength={150}
        />
        <Select
          classNameParent="col-12 mb-2"
          icon="fa fa-user-shield"
          text="Usuario del Sistema"
          options={workers.sort((a, b) => a.name_worker.localeCompare(b.name_worker)).map(u => ({ label: u.name_worker + ' ' + u.last_name_worker, value: u.id_worker }))}
          value={userOption}
          onChange={e => setRow({ ...row, p_id_worker: e?.value })}
        />
        <Select
          classNameParent="col-12 mb-2"
          icon="far fa-calendar-check"
          text="Jornada"
          options={optionsJourneyWorker}
          value={journey}
          onChange={e => setRow({ ...row, p_journey_worker: e.value })}
        />
        <SwitchToggle
          classNameParent="col-12 mb-2"
          textCheck="Es Jefe RRHH"
          textUnChecked="No Es Jefe RRHH"
          id="employee-is-boss-rrhh"
          defaultChecked={parseInt(row.p_is_boss_rrhh) === 1}
          onChange={e => setRow({ ...row, p_is_boss_rrhh: e.currentTarget.checked ? 1 : 0 })}
        />
        <SwitchToggle
          classNameParent="col-12 mb-2"
          textCheck="Es Jefe"
          textUnChecked="No Es Jefe"
          id="employee-is-boss"
          defaultChecked={parseInt(row.p_is_boss) === 1}
          onChange={e => {
            const checked = e.currentTarget.checked ? 1 : 0;
            setRow({
              ...row,
              p_is_boss: checked,
              // si es jefe, limpiar supervisor
              p_id_supervisor: checked === 1 ? '' : row.p_id_supervisor
            })
          }}
        />
        {parseInt(row.p_is_boss) === 1 ? <div className="col-12 mb-2"><small className="text-muted">Un Jefe no puede tener Supervisor.</small></div> : ''}
        <Select
          classNameParent="col-12 mb-2"
          icon="fa fa-user-tie"
          text="Jefe Directo"
          options={supervisorsOnly.map(e => ({ label: `${e.name_employee} ${e.last_name_employee}`, value: e.id_employee }))}
          value={supervisor}
          onChange={e => setRow({ ...row, p_id_supervisor: e?.value })}
          disabled={parseInt(row.p_is_boss) === 1}
        />
        <Input
          text="Apellidos"
          placeholder="Apellidos"
          classNameParent="col-12 mb-2"
          icon="far fa-comment-alt"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.last_name_employee}
          onChange={e => setRow({ ...row, p_last_name_employee: e.currentTarget.value })}
          maxLength={150}
        />
        <Input
          text="RFC"
          placeholder="RFC"
          classNameParent="col-12 mb-2"
          icon="far fa-id-card"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.rfc_employee}
          onChange={e => setRow({ ...row, p_rfc_employee: e.currentTarget.value })}
          maxLength={13}
        />
        <Input
          text="CURP"
          placeholder="CURP"
          classNameParent="col-12 mb-2"
          icon="far fa-id-card"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.curp_employee}
          onChange={e => setRow({ ...row, p_curp_employee: e.currentTarget.value })}
          maxLength={18}
        />
        <Input
          text="Código Postal"
          placeholder="Código Postal"
          classNameParent="col-12 mb-2"
          icon="far fa-id-card"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.zip_code_employee}
          onChange={e => setRow({ ...row, p_zip_code_employee: e.currentTarget.value })}
          maxLength={20}
        />
        <Input
          text="Fecha de Contrato"
          type="date"
          placeholder="Fecha de Contrato"
          classNameParent="col-12 mb-2"
          icon="far fa-calendar-alt"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.contract_date_employee}
          onChange={e => setRow({ ...row, p_contract_date_employee: e.currentTarget.value })}
        />
        <Input
          text="Salario"
          type="number"
          placeholder="Salario"
          classNameParent="col-12 mb-2"
          icon="far fa-money-bill-alt"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.salary_employee}
          onChange={e => setRow({ ...row, p_salary_employee: e.currentTarget.value })}
          min="0.01"
          step="0.01"
        />
        <Input
          text="SDI IMSS"
          placeholder="SDI IMSS"
          classNameParent="col-12 mb-2"
          icon="far fa-building"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.sdi_imss_employee}
          onChange={e => setRow({ ...row, p_sdi_imss_employee: e.currentTarget.value })}
        />
        <Input
          text="IMSS"
          placeholder="IMSS"
          classNameParent="col-12 mb-2"
          icon="far fa-building"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.imss_employee}
          onChange={e => setRow({ ...row, p_imss_employee: e.currentTarget.value })}
        />
        <Input
          text="Registro Patronal"
          placeholder="Registro Patronal"
          classNameParent="col-12 mb-2"
          icon="far fa-id-card"
          required
          invalid="El campo es obligatorio."
          defaultValue={data.employer_registration}
          onChange={e => setRow({ ...row, p_employer_registration: e.currentTarget.value })}
          maxLength={20}
        />
        {/* <Input
          text="Tipo de Salario"
          placeholder="Tipo de Salario"
          classNameParent="col-12 mb-2"
          icon="far fa-comment-alt"
          value="FIJO"
          disabled
        /> */}

        {/* SwitchToggle for Employee Enabled/Disabled */}
        <SwitchToggle
          text="Estado"
          classNameParent="col-12 mb-2"
          id="employee-enabled"
          defaultChecked={parseInt(row.p_enabled_employee) === 1}
          onChange={e => setRow({ ...row, p_enabled_employee: e.currentTarget.checked ? 1 : 0 })}
        />
      </FormCustom>
    </ReactPlaceholder>
  );
};

EmployeeForm.defaultProps = {
  data: {
    id_employee: '',
    name_employee: '',
    last_name_employee: '',
    rfc_employee: '',
    curp_employee: '',
    contract_date_employee: '',
    salary_employee: '',
    sdi_imss_employee: '',
    imss_employee: '',
    employer_registration: '',
    enabled_employee: '0', // Valor por defecto: Inactivo
    zip_code_employee: '',
    journey_worker: '',
    // Nuevos por defecto
    id_supervisor: '',
    is_boss: '0',
    is_boss_rrhh: '0',
    id_worker: '',
  },
  onSubmit: () => { },
  loadSubmit: false,
};

export default EmployeeForm;
